// extracted by mini-css-extract-plugin
module.exports = {"cardArtLink":"purify_index__cardArtLink--295rB","sizeToParent":"purify_index__sizeToParent--11w3v"};